import(/* webpackMode: "eager" */ "/app/src/app/(lyk-appp)/(sidebar)/subscriptions/view/page.tsx")